import refs from '../helpers/refs'

class CRecipeCards {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-recipe-cards')
    .forEach(el => new CRecipeCards(el))
})
